import { QUESTIONS_ROUTES } from '../../constants/_routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios, updateProgress } from '../../services'

// import { update_current_question } from './'
// import { try_force_logoff } from '../auth'

const upload_audio_request = () => {
  return {
    type: questionsTypes.upload_audio.request
  }
}

const upload_audio_success = (response) => {
  return {
    type: questionsTypes.upload_audio.success,
    payload: response.data
  }
}

const upload_audio_failure = (messages) => {
  return {
    type: questionsTypes.upload_audio.failure,
    payload: messages
  }
}

const upload_audio = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(upload_audio_request())

    // Request
    axios.post(
      QUESTIONS_ROUTES.upload_audio,
      values,
      {
        onUploadProgress: e => {
          // console.log(e)
          dispatch( updateProgress(e) )
        }
      }
    ).then( response => {
      // success
      dispatch( upload_audio_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error uploading audio."]
      }
      // dispatch( try_force_logoff(error.response) )
      window.showSnackbar('error', errors)
      dispatch( upload_audio_failure(errors))
    })
  }

}

export {
  upload_audio
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/upload_audio.js